import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },

  body: {
    fontFamily: "Poppins, sans-serif",
  },

  background: {
    height: "100%",
    width: "100%",
    alignItems: "center",
  },
  content: {
    flex: 1,
    justifyContent: "flex-end",

    padding: 32,
    paddingVertical: 52,
  },
  logo: {
    justifyContent: "center",
    alignItems: "center",
    height: "30vh",
  },
  imgLogo: {
    width: 150,
    height: 150,
    marginTop: "10%",
  },
  actionContainer: {
    maxWidth: 328,
    minHeight: 350,
    paddingBottom: 20,
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 36,
    paddingBottom: 36,
  },
  passwordContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    marginBottom: 0,
  },
  eyeButton: {
    padding: 12,
    zIndex: 100,
    position: "absolute",
    top: -10,
    right: 10,
  },
  actionButton: {
    padding: 10,
    width: "100%",
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    position: "relative",
  },
  actionButtonText: {
    textTransform: "uppercase",
    letterSpacing: 1,
    color: "#FFFFFF",
  },
  input: {
    position: "relative",
    padding: 10,
    paddingLeft: 12,
    width: "100%",
    maxWidth: 350,
    height: 36,
    borderRadius: 4,
    backgroundColor: "#FFF",
    opacity: 0.6,
    marginBottom: 40,
    alignSelf: "center",
    border: "0.5px solid #077A97",
  },

  forgotPasswordText: {
    color: "#24A2DC",
    textAlign: "left",
    fontSize: 14,
    fontWeight: 500,
    textTransform: "uppercase",
  },

  header: {
    marginTop: 20,
    padding: 15,
    marginLeft: "auto",
  },
  closeButton: {
    flexDirection: "row",
    alignItems: "center",
  },
  keepLogged: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "left",
    marginTop: 5,
    marginBottom: 10,
  },
  checkboxContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "left",
    paddingBottom: 20,
  },
  checkbox: {
    alignSelf: "center",
  },
  checkboxLabelContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
  checkboxLabel: {
    margin: 8,
    color: "#077A97",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  termsLink: {
    color: "#077A97",
    textDecorationLine: "underline",
  },
  loginPinContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  loginPinInner: {
    width: "90%",
    alignItems: "center",
  },

  labelInput: {
    color: "#077A97",
    marginBottom: 12,
    fontWeight: 500,
    fontSize: 14,
  },
});

export default styles;
